import { withRouter } from 'next/router';

const Footer = () => (
  <>
    <div className="limpia2 ">
      <div>
        <a href="https://www.instagram.com/liffaclub/" target="_blank" rel="noreferrer"><img title="Instagram Liffa Club" src="/img/liffaclub.png" className="izq" /></a>
        <a href="https://twitter.com/LIFFANATICO/" target="_blank" rel="noreferrer"><img title="Twitter Liffa Club" src="/img/liffanatico.png" className="der" /></a>
      </div>
    </div>
    <div> &nbsp; </div>
  </>

);

export default withRouter(Footer);
